import React from 'react';
import classNames from 'classnames';
import { useStyles } from './BalanceInputButton.styles';
export var BalanceInputButton = function (_a) {
    var value = _a.value, isActive = _a.isActive, onClick = _a.onClick;
    var classes = useStyles();
    return (React.createElement("div", { role: "button", tabIndex: 0, className: classNames(classes.button, isActive && classes.active), onClick: onClick },
        React.createElement("span", null, value)));
};
